import { CreditCard } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { formatCardNumber, formatExpiry, onlyDigits } from '@/lib/pagseguro';

export default function CreditCardFields({ cardForm, setCardForm, totalAmount }) {
  const updateField = (field, value) => {
    setCardForm({ ...cardForm, [field]: value });
  };

  return (
    <div className="space-y-4 p-4 border border-dashed border-accent rounded-lg bg-accent/5">
      <div className="flex items-center gap-2">
        <CreditCard className="w-5 h-5 text-accent" />
        <Label className="text-sm font-bold uppercase tracking-widest text-primary">
          Dados do Cartão
        </Label>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <Label className="text-xs font-bold uppercase text-primary mb-1">Nome impresso no cartão *</Label>
          <Input
            value={cardForm.holder_name}
            onChange={(event) => updateField('holder_name', event.target.value)}
            className="bg-white border border-border rounded-sm h-10 px-3 text-sm"
            autoComplete="cc-name"
            required
          />
        </div>

        <div className="md:col-span-2">
          <Label className="text-xs font-bold uppercase text-primary mb-1">Número do cartão *</Label>
          <Input
            value={cardForm.number}
            onChange={(event) => updateField('number', formatCardNumber(event.target.value))}
            className="bg-white border border-border rounded-sm h-10 px-3 text-sm"
            inputMode="numeric"
            autoComplete="cc-number"
            required
          />
        </div>

        <div>
          <Label className="text-xs font-bold uppercase text-primary mb-1">Validade *</Label>
          <Input
            placeholder="MM/AAAA"
            value={cardForm.expiry}
            onChange={(event) => updateField('expiry', formatExpiry(event.target.value))}
            className="bg-white border border-border rounded-sm h-10 px-3 text-sm"
            inputMode="numeric"
            autoComplete="cc-exp"
            required
          />
        </div>

        <div>
          <Label className="text-xs font-bold uppercase text-primary mb-1">CVV *</Label>
          <Input
            value={cardForm.security_code}
            onChange={(event) => updateField('security_code', onlyDigits(event.target.value).slice(0, 4))}
            className="bg-white border border-border rounded-sm h-10 px-3 text-sm"
            inputMode="numeric"
            autoComplete="cc-csc"
            required
          />
        </div>

        <div>
          <Label className="text-xs font-bold uppercase text-primary mb-1">Parcelas</Label>
          <select
            value={cardForm.installments}
            onChange={(event) => updateField('installments', event.target.value)}
            className="w-full bg-white border border-border rounded-sm h-10 px-3 text-sm"
          >
            {[1, 2, 3, 4, 5, 6].map((installment) => (
              <option key={installment} value={installment}>
                {installment}x de R$ {(totalAmount / installment).toFixed(2)}
              </option>
            ))}
          </select>
        </div>
      </div>

      <p className="text-xs text-foreground/60">
        Os dados do cartão são criptografados pelo SDK do PagBank antes do envio. O servidor recebe apenas o token seguro.
      </p>
    </div>
  );
}

